/// <reference types="vite/client" />

interface Config {
  sentryDsn: string;
  environment: Environment;
  sentryRelease: string;
  amplitudeApiKey: string | undefined;
}

export enum Environment {
  production = 'production',
  staging = 'staging',
  local = 'local',
}

let config: Config = {} as Config;
config = {
  sentryRelease: 'experimentation-engine-1985b0c-2026-09-02_23:23:34', // Replaced via script run during cloudbuild
  sentryDsn: import.meta.env.VITE_SENTRY_DSN!,
  environment: Environment[import.meta.env.VITE_ENVIRONMENT! as keyof typeof Environment],
  amplitudeApiKey: import.meta.env.VITE_AMPLITUDE_API_KEY,
}

export default config;
